import { CultureInfo } from '../culture-info.model';
import { CultureInfoEn } from './en';

/**
 * @ignore
 */
export const CultureInfoEnPR: CultureInfo = {
  name: 'en-PR',
  displayName: 'English (Puerto Rico)',
  iso3LanguageCode: 'eng',
  iso2LanguageCode: 'en',
  ietfLanguageTag: 'en-PR',
  parent: CultureInfoEn
};
